import { render } from "./ErrorLicenseAdmin.vue?vue&type=template&id=914923f4&scoped=true"
import script from "./ErrorLicenseAdmin.vue?vue&type=script&lang=js"
export * from "./ErrorLicenseAdmin.vue?vue&type=script&lang=js"

import "./ErrorLicenseAdmin.vue?vue&type=style&index=0&id=914923f4&lang=scss&scoped=true"
import "./ErrorLicenseAdmin.vue?vue&type=style&index=1&id=914923f4&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-914923f4"]])

export default __exports__